import { Users, Heart, Zap } from "lucide-react";
// framer-motion verwijderd uit dit component om de kritische homepage-bundle klein te houden.
// Entree-animatie via `animate-fade-in` (Tailwind keyframe in tailwind.config.ts).

const values = [
  {
    icon: Heart,
    title: "Persoonlijk",
    description:
      "Bij ons bel je geen servicedesk, maar krijg je direct een mens aan de lijn die jou en je bedrijf kent.",
  },
  {
    icon: Zap,
    title: "Simpel",
    description:
      "Wij geloven dat IT niet ingewikkeld hoeft te zijn. Daarom kiezen we bewust voor oplossingen die gewoon werken.",
  },
  {
    icon: Users,
    title: "Betrokken",
    description:
      "We denken met je mee — niet alleen over IT, maar over hoe technologie jouw werk makkelijker maakt.",
  },
];

const AboutSection = () => {
  return (
    <section className="py-20 md:py-28 bg-muted/40">
      <div className="container">
        <div className="mx-auto max-w-5xl">
          <div className="grid gap-12 md:grid-cols-2 md:items-center">
            {/* Text block */}
            <div className="animate-fade-in">
              <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-accent px-4 py-1.5 text-xs font-semibold text-accent-foreground">
                <span className="h-1.5 w-1.5 rounded-full bg-rinqel-green" />
                Over Rinqel
              </span>
              <h2 className="mt-4 text-3xl font-bold tracking-tight md:text-4xl">
                IT die draait om{" "}
                <span className="text-gradient">jou.</span>
              </h2>
              <p className="mt-4 text-lg leading-relaxed text-muted-foreground">
                Rinqel is er voor ondernemers die geen zin hebben in gedoe. 
                Geen ingewikkelde contracten, geen onverwachte facturen en geen 
                wachtrijen bij een anonieme helpdesk.
              </p>
              <p className="mt-3 text-lg leading-relaxed text-muted-foreground">
                Wij regelen je volledige IT-werkplek — van e‑mail en opslag tot 
                beveiliging en telefonie — voor een vast bedrag per maand. Alles 
                draait in de cloud, zodat jij overal veilig kunt werken. En heb 
                je een vraag? Dan bel je gewoon. Geen ticket, geen wachttijd, 
                maar direct iemand die je helpt.
              </p>
            </div>

            {/* Values */}
            <div className="flex flex-col gap-6 animate-fade-in [animation-delay:150ms]">
              {values.map((value, index) => (
                <div
                  key={value.title}
                  className="group flex gap-4 rounded-xl bg-card p-5 shadow-card transition-shadow hover:shadow-card-hover"
                >
                  <div
                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-primary-foreground ${
                      index === 0
                        ? "bg-hero-gradient"
                        : index === 1
                        ? "bg-rinqel-blue"
                        : "bg-rinqel-green"
                    }`}
                  >
                    <value.icon className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="font-semibold">{value.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                      {value.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
